module.exports = __webpack_public_path__ + "img/colors-flavors.7bedef50.jpg";